import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'gatsby';

const propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  to: PropTypes.string,
  href: PropTypes.string,
  variants: PropTypes.arrayOf(PropTypes.oneOf([
    'text', 
    'wide', 
    'full', 
    'empty', 
    'outline', 
    'primary-outline', 
    'padded', 
    'textNoTransform'])),
};

const defaultProps = {
  children: null,
  onClick: null,
  to: null,
  href: null,
  variants: [],
};

function Button({ to, href, className, children, variants, ...props }) {
  const variantClasses = variants.map(variant => `Button--${variant}`);
  const classes = classNames(className, 'Button', variantClasses);

  if (to !== null) {
    return (
      <Link {...props} className={classes} to={to}>
        {children}
      </Link>
    );
  }

  if (href !== null) {
    return (
      <a {...props} className={classes} href={href}>
        {children}
      </a>
    );
  }

  return (
    <button type="button" {...props} className={classes}>
      {children}
    </button>
  );
}

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;

export default Button;
